






import _ from "lodash";
import { createComponent } from "@vue/composition-api";
import fileDownload from "js-file-download";
import { useMegaraxClient } from "../../../shared/useMegaraxClient";

import CsvStringify from "csv-stringify/lib/sync";
interface Props {}

export default createComponent<Props>({
  components: {},
  props: {},
  setup(props, ctx) {
    const client = useMegaraxClient();
    async function downloadCsv() {
      const raw: any[] = await client
        .get("plm/productionRecipe/ingredientsTable")
        .then((r) => r.data);

      const allHeaders = _.chain<string[]>(raw)
        .flatMap(Object.keys)
        .uniq()
        .value();

      const csv = CsvStringify(raw, {
        header: true,
        columns: allHeaders,
      });

      fileDownload(csv, "skladniki_receptur_produkcyjnych.csv");
    }

    return { downloadCsv };
  },
});
